module.exports = [{
      plugin: require('/Users/alexson/dev/model-citizens/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/alexson/dev/model-citizens/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
